// extracted by mini-css-extract-plugin
export default {"container":"live-header-text-module--container--3uMgk","main":"live-header-text-module--main--Bfytz","back":"live-header-text-module--back--lwJRT"};